import AxiosProvider from '@/app/utils/api/axios-provider';
import {
  FilterPayload,
  CheckCodeSyntaxPayload,
} from '@/app/shared/types/params/code-meta-information-params.interface';
// TODO: ATBX-13547:rollback will be inmplemented for filters in backend and this will be updated to FilterLockAPIResponse
import { AttributeLockApiResponse } from '@/app/shared/types/stores/use-attribute-locker-api.resp.interface';
import { PaginationParams } from '@/app/shared/types/params/request-params.interface';
import { FilterOrDsLockPayload } from '@/app/shared/types/params/filter-lock-params.interface';
import { AxiosResponse } from 'axios';

const baseUrl = '/clients';
export default {
  getFilters(clientId: number, queryParams: PaginationParams) {
    return AxiosProvider.amsApiClient.get(`${baseUrl}/${clientId}/filters`, {
      params: { ...queryParams },
    });
  },
  getHistoryByFilterId(
    clientId: number,
    filterId: number,
    queryParams: PaginationParams
  ) {
    return AxiosProvider.amsApiClient.get(
      `/clients/${clientId}/filters/${filterId}/history`,
      {
        params: { ...queryParams },
        paramsSerializer: { indexes: null },
      }
    );
  },
  checkCodeSyntax(
    clientId: number,
    payload: CheckCodeSyntaxPayload
  ): Promise<unknown> {
    return AxiosProvider.amsApiClient.post(
      `/clients/${clientId}/filters/check-syntax`,
      payload
    );
  },
  lockFilterOrDs(
    filterOrDsLockPayload: FilterOrDsLockPayload
  ): Promise<AxiosResponse> {
    const { clientId, filterId, isAutoLock, dataSourceName } =
      filterOrDsLockPayload;
    return AxiosProvider.amsApiClient.post(
      `${baseUrl}/${clientId}/filters/${filterId}/lock`,
      undefined,
      {
        params: {
          isAutoLock,
          dataSourceName,
        },
      }
    );
  },
  unlockFilterOrDs(filterOrDsLockPayload: FilterOrDsLockPayload) {
    const { clientId, filterId, isAutoLock, dataSourceName } =
      filterOrDsLockPayload;
    return AxiosProvider.amsApiClient.post(
      `${baseUrl}/${clientId}/filters/${filterId}/unlock`,
      undefined,
      {
        params: {
          isAutoLock,
          dataSourceName,
        },
      }
    );
  },
  createFilter(clientId: number, filter: FilterPayload) {
    return AxiosProvider.amsApiClient.post(`${baseUrl}/${clientId}/filters`, {
      ...filter,
    });
  },
  updateFilter(
    clientId: number,
    filterId: number | string,
    filter: FilterPayload
  ) {
    return AxiosProvider.amsApiClient.patch(
      `${baseUrl}/${clientId}/filters/${filterId}`,
      {
        ...filter,
      }
    );
  },
  saveFilterCode(
    clientId: number,
    filterId: number | string,
    codeEntity: CheckCodeSyntaxPayload
  ): Promise<unknown> {
    return AxiosProvider.amsApiClient.post(
      `/clients/${clientId}/filters/${filterId}/save-code`,
      codeEntity
    );
  },
  copyFilter(
    filter: FilterPayload,
    clientId: number,
    filterId: number | string
  ) {
    return AxiosProvider.amsApiClient.post(
      `${baseUrl}/${clientId}/filters/${filterId}/copy`,
      { ...filter }
    );
  },
  getFilterById(clientId: number, filterId: number | string) {
    return AxiosProvider.amsApiClient.get(
      `${baseUrl}/${clientId}/filters/${filterId}`
    );
  },
  deleteFilters(clientId: number, filtersId?: Array<number>): Promise<unknown> {
    return AxiosProvider.amsApiClient.delete(`/clients/${clientId}/filters`, {
      data: filtersId,
    });
  },
  retrieveCyclicDependencies(clientId: number, selectedIds?: Array<number>) {
    return AxiosProvider.amsApiClient.get(
      `/clients/${clientId}/filters/cyclic-dependencies`,
      {
        params: {
          entityIds: selectedIds?.join(','),
        },
      }
    );
  },
  // TODO: ATBX-13547:rollback is only implemented in BackEnd for attributes
  rollbackFilterCode(
    clientId: number,
    rollbackRevisionId: number
  ): Promise<AttributeLockApiResponse> {
    return AxiosProvider.amsApiClient.post(
      `/clients/${clientId}/filters/rollback/${rollbackRevisionId}`
    );
  },
  getFilterArguments(
    clientId: number,
    filterId: number,
    datasourceName: string
  ) {
    return AxiosProvider.amsApiClient.get(
      `/clients/${clientId}/filters/${filterId}/arguments-count?datasourceName=${datasourceName}`
    );
  },
  validateFilterCode(
    clientId: number,
    filterId: number,
    dataSourceName: string,
    file: FormData,
    argumentsInput: Array<string>
  ) {
    return AxiosProvider.amsApiClient.post(
      `${baseUrl}/${clientId}/filters/${filterId}/validate?dsName=${dataSourceName}&arguments=${argumentsInput}`,
      file,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },
  getWhereUsedByFilterId(clientId: number, filterId: number) {
    return AxiosProvider.amsApiClient.get(
      `/clients/${clientId}/filters/${filterId}/where-used`
    );
  },
  checkDuplicateShortName(clientId: number, name: string) {
    return AxiosProvider.amsApiClient.get(
      `/clients/${clientId}/filters/${name}/check`
    );
  },
  lockAllFilters(clientId: number): Promise<unknown> {
    return AxiosProvider.amsApiClient.post(`/clients/${clientId}/FILTER/lock`);
  },
  unlockAllFilters(clientId: number): Promise<unknown> {
    return AxiosProvider.amsApiClient.post(
      `/clients/${clientId}/FILTER/unlock`
    );
  },
  lockAllDataSources(
    clientId: number,
    dataSourceName: string
  ): Promise<unknown> {
    return AxiosProvider.amsApiClient.post(
      `/clients/${clientId}/FILTER/lock?dataSourceName=${dataSourceName}`
    );
  },
  unlockAllDataSources(
    clientId: number,
    dataSourceName: string
  ): Promise<unknown> {
    return AxiosProvider.amsApiClient.post(
      `/clients/${clientId}/FILTER/unlock?dataSourceName=${dataSourceName}`
    );
  },
};
